/* ========================================================================
 * phoneField.js
 *
 * HTML structure:
 * <? class="phone-field">
 *   <input type="text" class="phone-field-full-input">
 *   <button class="phone-field-flyout-button" tabindex="-1"></button>
 *   <div class="flyout phone-field-flyout">
 *     <input type="text" class="phone-field-area-code" />
 *     <input type="text" class="phone-field-phone-number" />
 *     <input type="text" class="phone-field-extension" />
 *     <input type="text" class="phone-field-country-code" />
 *   </div>
 * </?>
 *
 * Plugin API:
 * $('.phone-field').phoneField();
 *
 * var api = $('.phone-field').data('phoneField');
 * var fullInputValue = api.getValue();
 * api.setValue(fullInputValue);
 * api.toggleEnabled(isEnabled);
 * ======================================================================== */

(function ($) {
  function keepFlyoutInWindow($flyout) {
    $flyout.css('left', '');
    var flyoutLeft = $flyout.offset().left;
    var flyoutRight = flyoutLeft + $flyout.outerWidth();
    if (flyoutRight > $(window).width())
      $flyout.css('left', $flyout.position().left - (flyoutRight - $(window).width()));
  }

  $.fn.phoneField = function () {
    $(this).each(function () {
      var $field = $(this);

      var $mainInput = $('.phone-full-input', $field);
      $field.copyFieldBooleanAttributes($mainInput);
      var $flyout = $('.phone-field-flyout', $field);
      var $countryCode = $('.phone-field-country-code', $flyout);
      var $areaCode = $('.phone-field-area-code', $flyout);
      var $phoneNumber = $('.phone-field-phone-number', $flyout);
      var $extension = $('.phone-field-extension', $flyout);

      var $flyoutButton = $('.phone-field-flyout-button', $field)
        .click(function (e) {
          if ($mainInput.isDisabled() || $mainInput.isReadonly())
            return false;

          if ($flyout.is(':visible'))
            $flyout.hide();
          else {
            $flyout.outerWidth($mainInput.outerWidth());
            $('.flyout').hide();
            $flyout.show();
            keepFlyoutInWindow($flyout);
          }
          return false;
        });

      $flyout.hide()
        .focus(function () { $flyout.show() }); // open flyout if any field in the flyout gets focus

      $(document).click(function (e) {
        if ($(e.target).parents().index($field) == -1)
          $flyout.hide();
      });

      $('input', $flyout).on('blur', function (e) {
        setTimeout(function () {
          if ($(':focus', $flyout).length == 0)
            $flyout.hide();
        }, 200);
      });

      var settingPhone = false;
      var setPhone = function (phone) {
        settingPhone = true;
        try {
          $mainInput.val(phone.format()).change();
          $countryCode.val(phone.countryCode).change();
          $areaCode.val(phone.areaCode).change();
          $phoneNumber.val(phone.number).change();
          $extension.val(phone.extension).change();
        }
        finally {
          settingPhone = false;
        }
      };

      var updateInputs = function () {
        if (settingPhone)
          return;

        var phone = new Legacy.PhoneNumber($countryCode.val(),
          $areaCode.val(),
          $phoneNumber.val(),
          $extension.val());

        setPhone(phone);
      };

      $mainInput.change(function () {
        if (settingPhone)
          return;

        var phone = Legacy.PhoneNumber.parse($(this).val());
        setPhone(phone);
      });
      if ($countryCode) {
        $countryCode.change(updateInputs);
      }
      $areaCode.change(updateInputs);
      $phoneNumber.change(updateInputs);
      $extension.change(updateInputs);

      updateInputs();

      var fieldObject = {
        getValue: function () {
          return $mainInput.val();
        },
        setValue: function (value) {
          $mainInput.val(value).change();
        },
        enable: function (enable) {
          if (typeof enable == "undefined" || enable)
            $field.enableChildren();
          else
            $field.disableChildren();
        },
        disable: function () {
          $field.disableChildren();
        }
      };
      $field.data("phoneField", fieldObject);
    });
  };
})(jQuery);
